import * as React from "react";

export const SvgPhone = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g>
			<path
				d="m17.56 13.743-2.233-2.232c-.797-.798-2.153-.479-2.472.558-.24.717-1.037 1.116-1.754.957-1.595-.4-3.748-2.472-4.147-4.147-.24-.718.24-1.515.957-1.754 1.037-.32 1.356-1.675.558-2.473L6.236 2.42c-.638-.559-1.595-.559-2.153 0L2.568 3.935c-1.515 1.595.16 5.821 3.907 9.57 3.748 3.747 7.975 5.501 9.57 3.907l1.515-1.515c.558-.639.558-1.595 0-2.154Z"
				fill={props.color ?? "#A8A8A8"}
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" transform="translate(2 2)" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);
